import { LuMessageCircle } from 'react-icons/lu';

/** Origin marker — makes it unmistakable that these rows come from the WhatsApp
 *  ingestion pipeline (not the morning-placeholder / scrape paths). */
export function WhatsAppOrigin() {
  return (
    <span className="inline-flex h-full items-center">
      <span className="inline-flex h-[20px] items-center gap-1 rounded-full bg-success/[0.14] px-2 text-[11px] font-semibold uppercase tracking-wide text-success">
        <LuMessageCircle size={12} />
        WhatsApp
      </span>
    </span>
  );
}
